import { useCallback, useRef, useState } from "react";
// * hooks
import {
  useMultiFileUploadMutation,
  useMultiMediaView,
} from "../hooks/fileUploadMutation";
import { useAuth } from "../services/auth";
import CustomImage from "./CustomImage";

const UploaderContainer = ({
  value,
  setValue,
  additionalClass,
}: {
  value: string[];
  setValue: (newValues: string[]) => void;
  additionalClass: string | undefined;
}) => {
  const { authData } = useAuth();

  const { mutate: uploadMutate, isLoading: uploadLoading } =
    useMultiFileUploadMutation(
      "fb507a0b75e0f62f65b798424555733f",
      // authData?.token ?? "",
      (objectKeyList: string[]) => {
        if (objectKeyList.length > 0 && objectKeyList[0] !== "") {
          setValue(objectKeyList);
        }
      },
      (_: any) => {}
    );
  const onFilesSelect = useCallback(
    (files: FileList | null) => {
      if (uploadLoading || files == null || files.length === 0) {
      } else {
        uploadMutate(files);
      }
    },
    [uploadMutate, uploadLoading]
  );

  return (
    <div className="h-24 flex flex-row">
      <Uploader
        onFilesSelect={onFilesSelect}
        additionalClass={additionalClass ?? ""}
      />
      {value.length > 0 ? <Previewer objectKeys={value} /> : null}
    </div>
  );
};

export default UploaderContainer;

const Uploader = ({
  onFilesSelect,
  additionalClass,
}: {
  onFilesSelect: (files: FileList | null) => void;
  additionalClass: string;
}) => {
  const fileRef = useRef<HTMLInputElement>(null);
  // * event handlers
  const onElementClick = useCallback(() => {
    if (fileRef.current) {
      fileRef.current.click();
    }
  }, []);
  const onChange = useCallback(
    (e: any) => {
      onFilesSelect(e.target.files);
    },
    [onFilesSelect]
  );

  return (
    <div
      onClick={onElementClick}
      className={`pt-6 pb-3 w-[200px] border border-bg01 border-dashed rounded-md bg-red-50 flex flex-col items-center cursor-pointer ${additionalClass}`}
    >
      <span className="text-sm">Click here to select file</span>
      <div className="mt-2 w-[100px] h-[30px] rounded bg-bg01 text-sm text-backgroundTertiary flex flex-col items-center justify-center  hover:opacity-80">
        Upload
      </div>
      <input
        ref={fileRef}
        multiple={false}
        type="file"
        accept="image/*"
        onChange={onChange}
        className="hidden"
      />
    </div>
  );
};

const Previewer = ({ objectKeys }: { objectKeys: string[] }) => {
  const { authData } = useAuth();

  return (
    <div className="mt-2 ml-12 w-32 flex flex-row">
      {objectKeys.length > 0
        ? objectKeys.map((src, index) => (
            <div
              className="border border-primary rounded-md overflow-x-auto"
              key={`previewer-image-${index}`}
            >
              <CustomImage
                // objectKey={authData?.token ?? ""}
                objectKey={src}
                token="fb507a0b75e0f62f65b798424555733f"
              />
            </div>
          ))
        : null}
    </div>
  );
};
